import { ReactNode } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';

export interface CardLinkProps {
  /** Optional className for Card, pass in a sass module class to override component default */
  className?: string;
  url: string;
  children: ReactNode;
}

export const CardLink = ({ className, url, children }: CardLinkProps) => {
  return (
    <Link className={cn('Card__Link', className)} to={url}>
      {children}
    </Link>
  );
};

export interface CardImageProps {
  /** Optional className for Card, pass in a sass module class to override component default */
  className?: string;
  imageSrc: string;
  count?: number;
}

export const CardImage = ({ className, imageSrc, count }: CardImageProps) => {
  return (
    <div className={cn('Card__Image', className)}>
      {count && <span className="Card__Count">{count}</span>}
      {imageSrc && <img src={imageSrc} />}
    </div>
  );
};

export interface CardFooterProps {
  /** Optional className for Card, pass in a sass module class to override component default */
  className?: string;
  children: ReactNode;
}

export const CardFooter = ({ className, children }: CardFooterProps) => {
  return <div className={cn('Card__Footer', className)}>{children}</div>;
};

export interface CardProps {
  /** Optional className for Card, pass in a sass module class to override component default */
  className?: string;
  children: ReactNode;
}

export const Card = ({ className, children }: CardProps) => {
  return <article className={cn('Card', className)}>{children}</article>;
};

Card.Image = CardImage;
Card.Footer = CardFooter;
Card.Link = CardLink;
